import SimpleModal from 'lib/modal/simple-modal';
import IconInformation from 'approot/shared/icons/icon-information';
import { PlayableComponentInfoButton } from '../shared/playable-component.style';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { StimulusAttribution } from 'approot/shared/stimulus/stimulus.constants';
import StimulusAttributionFields from 'approot/shared/stimulus/stimulus-attribution-fields';
import StimulusContentWarning from 'approot/shared/stimulus/stimulus-content-warning';
import { SimpleModalContentStyled } from 'lib/modal/simple-modal.styles';

type Props = {
  attribution: StimulusAttribution;
};

const VideoInfoModal = ({ attribution }: Props) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();
  return (
    <>
      <PlayableComponentInfoButton
        type="button"
        $borderRadius={40}
        aria-label="View attribution information"
        aria-haspopup
        onClick={openModal}
      >
        <IconInformation width={22} height={22} />
      </PlayableComponentInfoButton>

      {isVisible && (
        <SimpleModal
          title="Information"
          headerTitle="Information"
          isVisible={isVisible}
          onClose={closeModal}
        >
          <SimpleModalContentStyled>
            {attribution.contentWarning && <StimulusContentWarning />}
            <StimulusAttributionFields attribution={attribution} />
          </SimpleModalContentStyled>
        </SimpleModal>
      )}
    </>
  );
};

export default VideoInfoModal;
